import { StudentContent } from "../../components/accounting";

export default function Student() {
  return <StudentContent />;
}
